module.exports = __webpack_public_path__ + "static/img/yue.110edb7c.png";